import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from './login/login.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor(private router: Router, private loginService: LoginService) { }
  timer: number = 0;
  id: any;
  resetSession() {
    this.timer = 0;
    clearInterval(this.id);
    this.startSession();
  }

  startSession() {
    this.id = setInterval(() => {
      this.timer++;
      this.onSessionOut();
    }, 1000);

  }
  onSessionOut() {
    if (this.timer > 6000) {
      clearInterval(this.id);
      this.timer = 0;
      this.logout();
    }
  }

  logout() {
    clearInterval(this.id);
    this.timer = 0;
    localStorage.clear();
    sessionStorage.clear();
    this.removejscssfile("custome_script.js", "js");
    this.router.navigate(['/DSU/Login']);
   
    if (document.location.hostname == "localhost") {
      window.location.href = "http://localhost:4200/#/DSU/Login"
    } else {
      window.location.href = "https://dsu.uat.fmcone.in/#/DSU/Login"
    }
    clearInterval(this.id);
    this.timer = 0;
    location.reload();
  }

  removejscssfile(filename: string, filetype: string) {

    var targetelement = (filetype == "js") ? "script" : (filetype == "css") ? "link" : "none" //determine element type to create nodelist from
    var targetattr = (filetype == "js") ? "src" : (filetype == "css") ? "href" : "none" //determine corresponding attribute to test for
    var allsuspects = document.getElementsByTagName(targetelement)
    for (var i = allsuspects.length; i >= 0; i--) { //search backwards within nodelist for matching elements to remove
      if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) != null && allsuspects[i].getAttribute(targetattr).indexOf(filename) != -1)
        allsuspects[i].parentNode.removeChild(allsuspects[i]) //remove element by calling parentNode.removeChild()
    }
  }
}

